import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@environments/environment';

@Injectable({providedIn: 'root'})
export class InfluencerSsoService {
  private http = inject(HttpClient);

  private influencerSsoUrl = `${environment.apiUrl}/api/v1/influencer-sso`;

  getAll(params: any = {}) {
    return this.http.get(this.influencerSsoUrl, {params});
  }

  get(id: number) {
    return this.http.get(`${this.influencerSsoUrl}/${id}`);
  }

  create(setting: any) {
    return this.http.post(this.influencerSsoUrl, setting);
  }

  update(id: number, setting: any) {
    return this.http.put(`${this.influencerSsoUrl}/${id}`, setting);
  }

  delete(id: number) {
    return this.http.delete(`${this.influencerSsoUrl}/${id}`);
  }

  getAllowedForProject(projectId: number) {
    return this.http.get(`${this.influencerSsoUrl}/project/${projectId}`);
  }

}
